export default [
  {
    path: 'general-survey-apply',
    name: 'GeneralSurveyApply',
    meta: {
      isDynamic: true,
      id: '普查表申请记录',
      inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "GeneralSurveyApply" */ '@/views/DataManage/GeneralSurveyApply/GeneralSurveyApply.vue'
      )
  },
  {
    path: 'general-survey-data',
    name: 'GeneralSurveyData',
    meta: {
      isDynamic: true,
      id: '普查表客户数据',
      inTab: true
    },
    component: () =>
      import(
        /* webpackChunkName: "GeneralSurveyData" */ '@/views/DataManage/GeneralSurveyData/GeneralSurveyData.vue'
      )
  }
];
